export default {

  dateFormates:{
         short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
        daymonth:{
            year:"2-digit", month: 'long', day: 'numeric'
        },
  },  
        'Prova':'Race',
        'Regulamento':'Regulations',
        'Regras':'Rules',
        'Kit do Atleta':'Race Packet',
        'Trechos':'Course Legs',
        'Trecho':'Checkpoint',
        'Percurso':'Course',
        'Faltam':'Days Left',
        'dias':'days',
        'Distância':'Distance',
        'Previsão do Tempo':'Weather forecast',
        'Inscreva-se':'Register Now',
        'Altimetria':'Elevation',
        'Cal. de Ritmo':'Pace Rhythm',
        'Cálculo de Ritmo':'Pace Rhythm',
        'Selecione um horário':'Select Start Time',
        'Resultados':'Results',
        'Contato':'Contact',
        'Tempo total':'Total Time',
        'Média do Ritmo':'Average Pace',
        'Carregando':'Loading',
}